module.exports = __webpack_public_path__ + "static/img/4.9c8f64d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/7/zh/4.png
// module id = excy
// module chunks = 0